import {
    createSelector
} from 'reselect';

export const getToken = (state) => state.auth.token;
export const getUser = (state) => state.auth.user;

export const selectIsUserAuthorized = createSelector(
    [getToken, getUser],
    (token, user) => token && user && user.id && user.email ? true : false
);

export const selectUserIsActive = createSelector(
    [getUser],
    (user) => user && user.status ? true : false
);

export const selectUserType = createSelector(
    [getUser],
    (user) => user && user.typeId ? user.typeId : 0
);



// WEBPACK FOOTER //
// ./app/web/src/selectors/authSelectors.js